import ReceiptPrinterEncoder from '@point-of-sale/receipt-printer-encoder';

export const connectAndPrintUSB = async (dataToPrint) => {
    try {
        // Request USB device from the user. 
        // We leave filters empty so the user can select their specific printer.
        const device = await navigator.usb.requestDevice({ filters: [] });
        
        await device.open();
        
        // Select configuration if not already selected
        if (device.configuration === null) {
            await device.selectConfiguration(1);
        }
        
        // Claim the first interface
        await device.claimInterface(0); 

        // Initialize the encoder for standard ESC/POS
        const encoder = new ReceiptPrinterEncoder({
            language: 'esc-pos',
        });

        // Start building the binary data
        encoder
            .initialize()
            .align('center')
            .bold(true)
            .text('SHIPPING LABEL')
            .newline()
            .newline()
            .bold(false)
            .align('left');
            
        dataToPrint.forEach((registrant, index) => {
            const performers = registrant.performers || [];
            let nameToPrint = '', address = '', city = '', phone = '', zipCode = '';
            
            if (performers.length > 0) {
                nameToPrint = performers.map(p => p.fullName || `${p.firstName || ''} ${p.lastName || ''}`.trim()).join(' & ');
                city = String(performers[0].city || '');
                address = String(performers[0].addressLine || '');
                zipCode = String(performers[0].zipCode || '');
                phone = String(performers[0].phoneNumber || '');
            } else {
                nameToPrint = registrant.name || '';
            }
            
            // Print the full shipping details
            encoder
                .text(`Name: ${nameToPrint}`)
                .newline()
                .text(`Phone: ${phone}`)
                .newline()
                .text(`Addr: ${address}`)
                .newline()
                .text(`City: ${city}`)
                .newline()
                .text(`Zip: ${zipCode}`)
                .newline();
            
            // Add a separator between labels if printing multiple
            if (index < dataToPrint.length - 1) {
                encoder
                    .newline()
                    .text('--------------------------------')
                    .newline()
                    .newline();
            }
        });

        // Feed some lines before cutting (if printer supports cut)
        encoder.newline().newline().newline(); 

        const result = encoder.encode();

        // Find the "OUT" endpoint to send data to
        let outEndpoint;
        for (const endpoint of device.configuration.interfaces[0].alternate.endpoints) {
            if (endpoint.direction === "out") {
                outEndpoint = endpoint;
                break;
            }
        }
        
        if (!outEndpoint) {
            throw new Error("No OUT endpoint found on this USB device. It might not be a printer.");
        }

        // Send the raw binary data to the printer
        await device.transferOut(outEndpoint.endpointNumber, result);
        
        // Optionally close the device after printing
        await device.close();
        
        return { success: true };
    } catch (error) {
        console.error('USB Print Error:', error);
        return { success: false, error: error.message };
    }
};
